<div class="fx-row fx-gap-20px fx-align-start-center">
  <button mat-button id="x-button" (click)="onClose()" type="button" fxHide fxShow.xs>
    <mat-icon class="fx-align-center back-btn fx-row fx-align-simple-center">close
    </mat-icon>
  </button>
  <div *ngIf="title !== ''; else elseBlock">
    <h3>{{title}}</h3>
  </div>
  <ng-template #elseBlock>
    <div>
      <h3></h3>
    </div>
  </ng-template>
</div>